import { render, staticRenderFns } from "./feedbackDia.vue?vue&type=template&id=698626fc&scoped=true&"
import script from "./feedbackDia.vue?vue&type=script&lang=js&"
export * from "./feedbackDia.vue?vue&type=script&lang=js&"
import style0 from "./feedbackDia.vue?vue&type=style&index=0&id=698626fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "698626fc",
  null
  
)

export default component.exports